import { render, staticRenderFns } from "./edit-partner.vue?vue&type=template&id=74888b2a&scoped=true&"
import script from "./edit-partner.vue?vue&type=script&lang=js&"
export * from "./edit-partner.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner.vue?vue&type=style&index=0&id=74888b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74888b2a",
  null
  
)

export default component.exports